import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './styles.module.css';
import { CopyContentButton } from 'Shared/components/CopyContentButton';
import { EMDASH } from 'Shared/utils';

export type DisplayValuePairType = {
  display: React.JSX.Element | string;
  value: string;
};
export type InfoValuePairDataType =
  | React.JSX.Element
  | DisplayValuePairType
  | number
  | string
  | null
  | undefined;

export const isDisplayValuePair = (
  infoValue: InfoValuePairDataType
): infoValue is DisplayValuePairType => {
  if (
    infoValue === undefined ||
    infoValue === null ||
    typeof infoValue === 'string' ||
    typeof infoValue === 'number'
  )
    return false;
  return 'display' in infoValue;
};

export const InfoPair: FC<{
  dataClassName?: string;
  header: string;
  data: InfoValuePairDataType;
  dataFontStyle?: 'capitalize' | 'none';
  copyable?: boolean;
  loading?: boolean;
  dataTestIdPrefix?: string;
}> = ({
  header,
  data,
  dataClassName,
  dataFontStyle = 'capitalize',
  copyable = false,
  loading = false,
  dataTestIdPrefix,
}) => {
  return (
    <>
      <div className={classNames(styles.header)}>{header}</div>

      <div
        data-testid={prefixIfSpecified(
          `${header.toLowerCase().replace(/\s/g, '-')}`,
          dataTestIdPrefix
        )}
        className={classNames(
          styles.data,
          {
            [styles.capitalize]: dataFontStyle === 'capitalize',
          },
          dataClassName
        )}
      >
        <span
          className={classNames({
            [styles.loading]: loading,
          })}
        >
          {loading
            ? 'EMPTY VALUE'
            : isDisplayValuePair(data)
              ? data.display
              : (data ?? EMDASH)}
        </span>
        {data && data !== EMDASH && copyable && !loading && (
          <CopyContentButton
            className={styles.copyButton}
            value={isDisplayValuePair(data) ? data.value : data}
          />
        )}
      </div>
    </>
  );
};

const prefixIfSpecified = (text: string, prefix?: string): string =>
  prefix === undefined ? text : `${prefix}-${text}`;
